import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-home-tree',
  templateUrl: './icon-home-tree.component.html',
  styleUrls: ['./icon-home-tree.component.scss']
})
export class IconHomeTreeComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
